import React from "react";
import { Link } from 'react-router-dom';

const PageNotFound = () =>
  <div className="spacetab text-center">
  <h1 className="text-center pnf">404</h1>
  <h2 className="text-center pnf1">OOPS, THE PAGE YOU ARE LOOKING FOR CAN&apos;T BE FOUND!</h2>
  <Link to="/" className="btn  pnfbutton ">GO TO HOMEPAGE</Link>
  </div>
export default PageNotFound;